import type {
	AdminNewsMnemonicsResponseDto,
	AdminRepairMnemonicsResponseDto
} from '../dto/admin';
import { httpArg, httpGet, httpPost, httpRoute, httpUserId } from '../infrastructure/http/http-decorators';

@httpRoute('/api/admin/mnemonics')
export abstract class IMnemonicAdminService {
	@httpGet('articles')
	getArticles(
		@httpArg('page') page: number,
		@httpArg('limit') limit: number,
		@httpArg('dateFrom') dateFrom?: string,
		@httpArg('dateTo') dateTo?: string,
		@httpArg('sourceLang') sourceLang?: string,
		@httpArg('targetLang') targetLang?: string,
		@httpUserId() userId?: string
	): Promise<AdminNewsMnemonicsResponseDto> {
		void page;
		void limit;
		void dateFrom;
		void dateTo;
		void sourceLang;
		void targetLang;
		void userId;
		throw new Error('Not implemented');
	}

	@httpPost('repair')
	repairMnemonics(
		@httpArg('articleIds') articleIds: readonly string[],
		@httpUserId() userId?: string
	): Promise<AdminRepairMnemonicsResponseDto> {
		void articleIds;
		void userId;
		throw new Error('Not implemented');
	}
}

